import { useEffect, useState } from "react";

import { fetchSingleSoftwareMaintenanceHistory } from "@api/inventory/software";

export const useSingleSoftwareMaintenanceHistory = (
  softwareId: string | number,
  softwareMaintenanceId: number | null,
) => {
  const [singleData, setSingleData] = useState<any>({});
  const [getError, setGerError] = useState(false);

  useEffect(() => {
    if (softwareId && softwareMaintenanceId) {
      fetchSingleSoftwareMaintenanceHistory(softwareId, softwareMaintenanceId)
        .then((data: any) => {
          setSingleData(data?.data);
        })
        .catch((err: any) => setGerError(err));
    }
  }, [softwareId, softwareMaintenanceId]);

  return {
    singleData,
    getError,
  };
};
